import { Button, Select } from '@cloudflare/kumo';
import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { SearchField } from './ui/SearchField';
import { TagCombobox, TagCount } from './atlas/TagCombobox';

interface Category {
  id: string;
  nome: string;
}

interface SearchAndFiltersProps {
  search: string;
  selectedCategory: string;
  tags: string[];
  tagOptions: TagCount[];
  onSearchChange: (search: string) => void;
  onCategoryChange: (categoryId: string) => void;
  onTagsChange: (tags: string[]) => void;
  onClearFilters: () => void;
}

/** O `Select` do Cloudscape não aceita valor vazio: "todas" vira esta sentinela. */
const ALL_CATEGORIES = '__all__';

/** Filtros da lista de contatos: busca, tags em chips (o contato precisa ter todas) e categoria */
export function SearchAndFilters({
  search, selectedCategory, tags, tagOptions, onSearchChange, onCategoryChange, onTagsChange, onClearFilters,
}: SearchAndFiltersProps) {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    apiService.getCategories()
      .then((res) => setCategories(res.categories || []))
      .catch(() => {});
  }, []);

  const options = [
    { value: ALL_CATEGORIES, label: 'Todas as categorias' },
    ...categories.map((cat) => ({ value: cat.id, label: cat.nome })),
  ];
  const selectedOption = options.find((o) => o.value === (selectedCategory || ALL_CATEGORIES)) ?? null;

  return (
    <div className="atlas-filters">
      <div className="atlas-filters__search">
        <SearchField
          ariaLabel="Buscar contatos"
          placeholder="Buscar por nome, telefone ou e-mail..."
          value={search}
          onChange={onSearchChange}
        />
      </div>
      <div className="atlas-filters__tags">
        <TagCombobox ariaLabel="Filtrar por tags" placeholder="Filtrar por tags" value={tags} onChange={onTagsChange} options={tagOptions} />
      </div>
      <div className="atlas-filters__select">
        <Select value={(selectedOption)?.value ?? null} items={options} onValueChange={(value: string | null) => onCategoryChange(value === ALL_CATEGORIES ? '' : value ?? '')} aria-label="Filtrar por categoria" placeholder="Todas as categorias" />
      </div>
      {(search || selectedCategory || tags.length > 0) && (
        <Button variant="secondary" onClick={onClearFilters}>Limpar filtros</Button>
      )}
    </div>
  );
}
